import styled from 'styled-components';
import CustomCard from '@components/CustomCard';

export const FiltersCardContainer = styled(CustomCard)`
  margin-bottom: 16px;

  .ant-card-body {
    padding: 24px;
    max-height: 300px;
    overflow: auto;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    background: ${({ theme }) => theme.colors.background1} !important;

    .ant-tag span {
      font-weight: bold;
    }
  }

  /* .filters-card-header {
    margin: -8px;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
  } */
`;
